var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEletric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 45,
    viewBox: "0 0 29 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.552 44.764 17.357-29.887a.94.94 0 0 0-.94-1.403l-11.545 1.569L18.182.56c.093-.488-.536-.768-.836-.372L.28 22.715c-.497.657.029 1.59.848 1.503l12.729-1.34-4.173 21.56c-.1.52.602.784.868.326z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.617 21.119a.39.39 0 0 1-.361-.594L18.016.109c-.19-.15-.49-.16-.67.08L.28 22.714c-.497.657.029 1.59.848 1.503l12.729-1.34-4.173 21.56c-.057.291.14.496.369.545l7.15-22.627a1.567 1.567 0 0 0-1.619-2.034l-9.967.797z",
    fill: "#FFC850"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEletric);
export default __webpack_public_path__ + "static/media/eletric.be0d9fb4dc9bb28ac36a087d6e632afc.svg";
export { ForwardRef as ReactComponent };